import { useQuery } from "@tanstack/react-query";

import { getWithdrawalApprovalWithdrawalRequestID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { WITHDRAWAL_APPROVALS_QUERY_KEYS } from "./queryKeys";

export function useWithdrawalApprovalDetailQuery(
  withdrawalRequestID: string | undefined,
) {
  return useQuery({
    queryKey: WITHDRAWAL_APPROVALS_QUERY_KEYS.detail(withdrawalRequestID ?? ""),
    queryFn: processResponse(() =>
      getWithdrawalApprovalWithdrawalRequestID(withdrawalRequestID ?? ""),
    ),
    enabled: !!withdrawalRequestID,
  });
}
